import type { PriceScenariosProps } from "../../types";
import { Arrow } from "../Arrow";
import { Badge } from "../Badge";

export const BadgeWithArrow = (props: PriceScenariosProps) => (
  <Arrow>
    <Badge {...props} />
  </Arrow>
);
